<template>
  <div id="app">
    <el-container>
      <el-header class="div-header PrintHideArea">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div">
        <el-container class="parentDiv" v-loading="loading">
              <div class="SID0008_DilaogDiv" v-loading.fullscreen.lock="fullscreenLoading">
                <!-- Breadcrumb section -->
                <section>
                    <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegisterLink">
                        <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '' }">本文テキスト表示</el-breadcrumb-item>
                    </el-breadcrumb>
                </section>
                <br>
                <!-- Full container div start -->
                <!--First Dialog body section -->
                <section>
                    <el-dialog
                        title=""
                        :visible.sync="getdialogVisible "
                        close="false"
                        :close-on-click-modal="false"
                        class="SID0009_DilaogDiv PrintHideArea"
                        >
                        <!-- <el-container> -->
                            <div class="SID0009__popupScreen">
                              <!--
                              * Backlog issue related fix
                              * Author: BM
                              * Backlog Id: BT08460_EXTERNAL-1674
                              * The text could not be obtained because the upper limit of the original text was exceeded. "
                              -->
                              <div class="firstSpan">
                                    <span>原文利用上限値を超過したため、本文テキストを取得することができませんでした。</span>
                                </div>
                                <div class="ButtonClose">
                                    <el-button type="info" plain @click="closeTab">閉じる</el-button>
                                </div>
                            </div>
                    <!-- </el-container> -->
                    </el-dialog>
                </section>
                <!-- 2021/12/7  #11849  START -->
                <!--Second Dialog body section -->
                <!--  <section> -->
                <!--      <el-dialog -->
                <!--          title="" -->
                <!--          :visible.sync="permission_error_dialog" -->
                <!--          close="false" -->
                <!--          :close-on-click-modal="false" -->
                <!--          class="SID0009_DilaogDiv2 PrintHideArea" -->
                <!--          > -->
                <!--              <div class="SID0009__popupScreen2"> -->
                <!--                  <div class="FirstSpan2"> -->
                <!--                      <span>ご利用のユーザーは本文テキストを表示できません。</span> -->
                <!--                  </div>   -->
                <!--                  <div class="ButtonClose2"> -->
                <!--                      <el-button type="info" plain @click="closeTab">閉じる</el-button> -->
                <!--                  </div> -->
                <!--              </div> -->
                <!--      </el-dialog> -->
                <!--  </section> -->
                <!-- 2021/12/7  #11849  END -->
                <!--Third Dialog body section -->
                  <section>
                    <el-dialog
                        title=""
                        :visible.sync="getdialogVisible2"
                        close="false"
                        :close-on-click-modal="false"
                        class="SID0009_DilaogDiv3 PrintHideArea"
                        >
                        <!-- <el-container> -->
                            <div class="SID0009__popupScreen3">
                                <div class="FirstSpan3">
                                    <span>要求された記事は表示できません。</span>
                                </div>  
                                <div class="ButtonClose3">
                                    <el-button type="info" plain @click="closeTab">閉じる</el-button>
                                </div>
                            </div>
                    <!-- </el-container> -->
                    </el-dialog>
                </section>
                <!-- Topic Header section -->
                <section class="PrintHideArea" v-if="canViewText && !getdialogVisible && !getdialogVisible2">
                    <el-row>
                        <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                        <el-col :span="3" :xs="24">
                        <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                            <div class="newsImage">
                                <img src="/img/logo-new.10b4eb61.png" alt="LOGO" />
                            </div>
                        </el-col>
                        <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                        <el-col :span="21" :xs="24">
                        <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                            <div class="TopicHeaderText">
                                <span>{{ articleTitle }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-divider class="dividerHeaderTop"></el-divider>
                    <el-row class="subTitleColumn">
                      <el-col :span="3">{{ articleCategory }}</el-col>
                      <el-col :span="4">{{ articleDate }}</el-col>
                      <el-col :span="2">{{ articleEdition }}</el-col>
                      <el-col :span="2">{{articleTotalPages}}</el-col>
                      <el-col :span="2" v-if="articleTotalSteps != ''">{{articleTotalSteps}}</el-col>
                      <el-col :span="2" v-if="articleClassification != ''">{{articleClassification}}</el-col>
                      <el-col :span="4" v-if="sheetsInArticle != ''">{{articleInformation}} {{sheetsInArticle}}</el-col>
                    </el-row>
                    <el-divider class="dividerHeaderBottom"></el-divider>
                </section>
                <!-- Notic information section -->
                <section class="PrintHideArea" v-if="canViewText && !getdialogVisible && !getdialogVisible2">
                    <div class="noticInformation">
                        <span>&lt;コメント&gt;</span>
                        <span v-html="articleComment"></span>
                    </div>                                  
                    <el-divider class="dividerHeaderMiddle"></el-divider>
                    <div class="noticInformation">
                      <span>&lt;検索語&gt;</span>
                      <br>
                      <span>{{ searchWord}}</span>
                    </div>  
                    <el-divider class="dividerHeaderMiddle"></el-divider>                             
                </section>
                <!-- Print section -->
                <section v-if="canViewText && !getdialogVisible && !getdialogVisible2">
                   <el-row class="PrintHideArea" >
                     <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 START-->
                     <el-col :span="10" :xs="0" style="min-height:1px;">
                     </el-col>
                     <el-col :span="4" :xs="24" class="buttonPrint">
                       <el-button type="primary" plain @click="print" v-if="canPrintText">印刷</el-button>
                     </el-col>
                     <el-col :span="10" :xs="24" class="buttonFontSizeChange">
                       <el-row>
                         <span style="margin-right: 10px;">文字サイズ</span>
                         <el-button type="primary" plain v-on:click="FontDecrease" class="activeFont" v-bind:class="{ activeButton: isActive }">小</el-button>
                         <el-button type="primary" plain v-on:click="FontReset" class="activeFont" v-bind:class="{ activeButton: isMedActive }">中</el-button>
                         <el-button type="primary" plain v-on:click="FontIncrease" class="activeFont" v-bind:class="{ activeButton: isBigActive }">大</el-button>
                       </el-row>
                     </el-col>
                     <!-- 2022/09/01 No8. 本文テキストの画面幅にあわせた改行 END-->
                    </el-row> 
                    <div id="printAreaContent" class="PopupBodyContent smallFontSize mediumFontSize largeFontSize">
                        <span v-html="getArticleText"></span>
                    </div>
                     <el-divider class="dividerLineBottom PrintHideArea"></el-divider>     
                </section>
                
                <!-- Bottom section -->
                <section class="PrintHideArea" v-if="canViewText && !getdialogVisible && !getdialogVisible2">
                    <el-button type="info" plain @click="closeTab">閉じる</el-button>
                </section>
                <!-- Full container section End -->
              </div>
        </el-container>
      </div>

      <el-container class="PrintHideArea footer-div" v-if="canViewText && !getdialogVisible && !getdialogVisible2">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Header from "../common/header.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import $ from "jquery";
import router from "../../router";
import Vue from "vue";

export default {
  name: "PopupFontChangeScreen",
	components: {
		Header,
		FooterComponent,
  },
  data() {
		return {			
      isActive: false,
      isMedActive: true,
      isBigActive: false,
      articleTotalPages: "",
      articleTotalSteps: "",
      articleClassification: "",
      articleInformation: "",
      sheetsInArticle: "",
      printOptions: '',
      mediaWeb:'0',
      articleImage: '',
      articleTitle : '',
      articleCategory: '',
      articleDate: '',
      articleEdition: '',
      articleComment: '',
      searchWord:'',
      canPrintText: false,
      canViewText: false,
      print_text_confirm_message_flag: "",
      userId:'',
      contractId:'',
      theme_browsing:false,
      contract_code:'',
      message_info: [],
      user_group_name : '',
      user_group_linkage:[],
      is_mail: false,
      permission_error_dialog: false,
      loading:false,
      pdf_confirm_message_flag: "",
      text_confirm_message_flag: "",
      print_confirm_message_flag: "",
      fontSizeChangeFlag: 1,
      fullscreenLoading: false,
    };
  },
  methods: {
    print () {
      this.$LogButtonEvent("0008","Printing");
      this.$LogMethodIN("0008","print");
      var article_type_change_to_int = this.$route.query.data_section;
       var article_type = parseInt(article_type_change_to_int);
      //var current_display_id  =this.$route.query.display_id;
      var pdfValues = {
        pdf_flag:4,
        article_info:[
          {
            article_id: this.$route.query.articleId,
            data_section:article_type,
          }
        ],
        user_id: this.userId,
        contract_code: this.contract_code,
        theme_browsing: this.theme_browsing,
        // 2021/10/11  #11849  START
        display_id: 'SID0008',
        // 2021/10/11  #11849  END
        is_mail:this.is_mail
      };

      var printSuccessValues = {
        data_info:[
          {
            contract_id: this.contractId,
            data_section: article_type,
            user_id: this.userId,
            read_count:1,
            request_div:4,
            article_id: this.$route.query.articleId,
            user_group_name: this.user_group_name,
          }
        ],
        is_mail:this.is_mail
      }
      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag){
        this.$confirm(this.getDemandConfirmPrintTextMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm")
            {
              this.fullscreenLoading = true;
              this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.fullscreenLoading = false;
              })
              done();
            }
            else
            {
              done();
            }
          }
        });
      }
      else
      {
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      this.$LogMethodOut("0008","print");
    },
    closeTab(){
      this.$LogButtonEvent("0008","Close");
      this.$LogMethodIN("0008","closeTab");
      // 2021/11/19  #12251  START
      var mailFlag = Vue.prototype.$session.get('mailFlagForCloseButton')
            if(mailFlag)
            {
                router.push('/0002');
            }
            else
            {
                window.close();
            }
      // 2021/11/19  #12251  END
      this.$LogMethodOut("0008","closeTab");
    },
    FontDecrease() {
      
      this.$LogButtonEvent("0008","Small");
      this.$LogMethodIN("0008","FontDecrease");
      $(".smallFontSize span").css("font-size", "calc(10.4pt * 0.8)");
      this.isActive = true;
      this.isMedActive = false;
      this.isBigActive = false;
      this.fontSizeChangeFlag = 1;
      this.$LogMethodOut("0008","FontDecrease");     
    },
    FontReset() {
      this.$LogButtonEvent("0008","During");
      this.$LogMethodIN("0008","FontReset");
      $(".mediumFontSize span").css("font-size", "10.4pt");
      this.isActive = false;
      this.isMedActive = true;
      this.isBigActive = false;
      this.fontSizeChangeFlag = 2;
      this.$LogMethodOut("0008","FontReset");        
    },
    FontIncrease() {
      this.$LogButtonEvent("0008","Big");
      this.$LogMethodIN("0008","FontIncrease");
      $(".largeFontSize span").css("font-size", "calc(10.4pt * 1.3)");
      this.isActive = false;
      this.isMedActive = false;
      this.isBigActive = true;
      this.fontSizeChangeFlag = 3;
      this.$LogMethodOut("0008","FontIncrease");        
    },
    afterprint(){
      if(this.printOptions == 0)
      {
        var inputPDFCountData = {
              data_info:[{
                data_section: 1,
                read_count:1,
                request_div:4,
                user_id: this.userId,
                article_id:this.$route.query.articleId,
                User_group_name: this.user_group_name
              }]
          };
          this.$store.dispatch('communication0008/pdfRequestDisplay',inputPDFCountData);
      }else{
          this.mediaWeb = '1'
      }
    },
    getMessageInfoFromSession(){
      var message_info = this.message_info
      for(var u=0;u<message_info.length;u++)
      {
        if(message_info[u].message_key == "demandConfirmPrintTextMessage")
        {
          this.print_text_confirm_message_flag = message_info[u].configuration_value;
        }
        else if(message_info[u].message_key == "demandConfirmPdfMessage")
        {
          this.pdf_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmTextMessage")
        {
          this.text_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmPrintMessage")
        {
          this.print_confirm_message_flag = message_info[u].configuration_value
        }
        else
        {
          //no action needed
        }
      }
    },
    getConfigurationFromSession(){
      //get the user group linkage info value from the session
      var user_group_linkage = this.user_group_linkage

      for(var k=0;k<user_group_linkage.length;k++)
      {
        if(user_group_linkage[k].data_section == 1 || user_group_linkage[k].data_section == 2)
        {
          if(user_group_linkage[k].media_window_size == 3)
          {
            this.isActive = false;
            this.isMedActive = false;
            this.isBigActive = true;
            this.fontSizeChangeFlag = 3;   
          }
          else if(user_group_linkage[k].media_window_size == 2)
          {
            this.isActive = false;
            this.isMedActive = true;
            this.isBigActive = false;
            this.fontSizeChangeFlag = 2;
          }
          else
          {
            this.isActive = true;
            this.isMedActive = false;
            this.isBigActive = false;
            this.fontSizeChangeFlag = 1;
          }

        }
        else
        {
          //no action needed
        }
      }
    },
    createData(article_type)
    {
      if(article_type == 1)
      {
        var mcarticle  = this.getNewsArticledata;
        var McArticle = []
        if(mcarticle){
            McArticle = mcarticle
        } 
        for(var i=0;i<McArticle.length;i++)
        {
          if(McArticle[i].issue_date != "" && McArticle[i].media_name != "")
          {
            this.articleTitle = McArticle[i].article_title; 
            this.articleCategory = McArticle[i].media_name;
            this.articleDate     = McArticle[i].issue_date;
            this.articleEdition = McArticle[i].articleEdition;
            this.articleComment = McArticle[i].article_comment != " null" ? McArticle[i].article_comment : "";
            this.searchWord = McArticle[i].search_word != " null" ? McArticle[i].search_word : "";
            this.articleTotalPages = McArticle[i].frame_no + '面';
            this.articleTotalSteps = McArticle[i].head_no + '段';
            this.articleClassification = McArticle[i].article_class;
            this.articleInformation = McArticle[i].note;
            this.sheetsInArticle = McArticle[i].image_count;
            if(this.sheetsInArticle != null && this.sheetsInArticle != '')
            {
              this.sheetsInArticle = '枚数(' + this.sheetsInArticle + ')';
            }
            else
            {
              this.sheetsInArticle = '';
            }
            this.articleImage = McArticle[i].image; // "/img/logo-new.10b4eb61.png"
          }
        }

      }
      else
      {
        var scarticle  = this.getNikkieArticledata;
        var ScArticle = []
        if(scarticle){
          ScArticle = scarticle;
        }
        for(var j=0;j<ScArticle.length;j++)
        { 

          if(ScArticle[j].issue_date != "" && ScArticle[j].media_name != ""){ 
              this.articleTitle = ScArticle[j].title;
              this.articleCategory = ScArticle[j].media_name;
              this.articleDate     = ScArticle[j].issue_date;
              this.articleEdition = ScArticle[j].articleEdition;
              this.articleComment = ScArticle[j].comment != " null" ? ScArticle[j].comment : "";
              this.articleTotalPages = ScArticle[j].frame_no + '面';
              this.articleImage = ScArticle[j].image;
            }
            
        }
          
      }
    }
  }, 
  computed: {
    ...mapGetters("situation0008", ["getArticleId",
      "getArticleTitle",
      "getArticleMediumName",
      "getArticleIssueDate",
      "getArticleType",
      "getArticleComment",
      "getArticleText",
      "getframeno",
      "getdatasection",
      "getheadno",
      "gettrace",
      "getnote",
      "getarticleImagecount",
      "getStatus",
      "getorginalComment",
      "getorginalTitle",
      "getdialogVisible2",
      "getdialogVisible"]),
    ...mapGetters("situation0006", [
      "getNewsArticledata",
      "getNikkieArticledata"
      ]),
    ...mapGetters("situation0001", ["getUserId",
      "getContractId",
      "getThemeBrowsing",
      "getContractCode",
      "getMC_Text_View_Flag",
      "getMC_Text_Print_Flag",
      "getMessageInfo",
      "getUserGroupLinkageInfo",
      "getUserGroupName",
      "getDemandConfirmPrintTextMessage",
      "getOut_Demand_Confirm_Message_Div_Flag"])
  },
  mounted(){
    this.loading=true;
     //get the user id value from session
    this.userId = this.getUserId

    //get the contract_id value from session
    this.contractId = this.getContractId

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing

    //get the contract code value from session
    this.contract_code = this.getContractCode

    this.canViewText = this.getMC_Text_View_Flag
    this.canPrintText = this.getMC_Text_Print_Flag
    this.permission_error_dialog = !this.canViewText

    this.message_info = this.getMessageInfo
    this.user_group_name = this.getUserGroupName
    this.user_group_linkage = this.getUserGroupLinkageInfo

    var article_type_change_to_int = this.$route.query.data_section;
    var article_type = parseInt(article_type_change_to_int);
    
    /*** Change by SJ for backlog Id: 1563 **/
    //var current_display_id=this.$route.query.display_id;
    this.is_mail = (this.$route.query.is_mail == "true" ||this.$route.query.is_mail == true)
    var pdfValues = {
      pdf_flag:3,
      article_info:[
        {
          article_id: this.$route.query.articleId,
          data_section:article_type,
        }
      ],
      user_id:this.userId,
      contract_code:this.contract_code,
      theme_browsing:this.theme_browsing,
        // 2021/10/11  #11849  START
        display_id: 'SID0008',
        // 2021/10/11  #11849  END
      is_mail:this.is_mail
    };
    var bodytextview_requestlog = {
        data_info:[{
        contract_id: this.contractId,
        data_section: article_type,
        user_id: this.userId,
        read_count:1,
        request_div:3,
        article_id: this.$route.query.articleId,
        user_group_name: this.user_group_name,
        }],
        is_mail:this.is_mail
      }
    
    this.$store.commit('situation0008/setTitle', this.$route.query.articleTitle); 
    this.$store.dispatch('communication0008/getBodyText', pdfValues).then(()=>{
      // 2021/01/07  #10234  START
      //this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
      if (!this.getdialogVisible && !this.getdialogVisible2){
        this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
      }
      // 2021/01/07  #10234  END
      var conditions = this.$route.query.printOption;
      if(conditions){
          this.printOptions = 0;
          
      }else{
          this.mediaWeb = '1';
      }
      

      var getDataArticleIds = [];
      var article_detail = {}
      article_detail.data_section = article_type;
      article_detail.article_id = this.$route.query.articleId
      getDataArticleIds.push(article_detail)
      this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds,is_mail: this.is_mail}).then(() => {
          this.createData(article_type);
          this.loading=false;
      })
      
    }).catch(()=>{
      this.loading=false;
    });
    
    this.getMessageInfoFromSession();
    this.getConfigurationFromSession();
  },
  created() { 
    //For the screen Title
    document.title = "記事閲覧";

  },
  updated() {
    if(this.fontSizeChangeFlag == 1)
    {
      $(".smallFontSize span").css("font-size", "calc(10.4pt * 0.8)");
    }
    else if(this.fontSizeChangeFlag == 2)
    {
      $(".mediumFontSize span").css("font-size", "10.4pt");
    }
    else if(this.fontSizeChangeFlag == 3)
    {
      $(".largeFontSize span").css("font-size", "calc(10.4pt * 1.3)");
    }
    else
    {
      //no action needed
    }
  },
}
</script>

<style scoped>
  @import "0008.css";
</style>
<style scoped>
  @import "../0009/0009.css";
</style>
<style type="text/css">
  @media print {
    .PrintHideArea{
      display:none;
    }
    .el-message-box__wrapper{
      display:none;
    }
  }
</style>